import React from "react";

const PricingPlansSection = () => {
  // Data for Internet Plans
  const plans = [
    {
      id: 1,
      name: "Starter",
      speed: "10 Mbps",
      price: "8,000 AF",
      period: "/mo",
      features: [
        "Perfect for 1-2 devices",
        "Standard WiFi Router",
        "Basic Security",
        "Unlimited Data",
      ],
      popular: false,
    },
    {
      id: 2,
      name: "Streamer",
      speed: "5 Mbps",
      price: "4,000 AF",
      period: "/mo",
      features: [
        "Perfect for 4K Streaming",
        "Smart Mesh WiFi 6",
        "Advanced Security Suite",
        "Unlimited Data",
        "Priority Support",
      ],
      popular: true,
    },
    {
      id: 3,
      name: "Gamer",
      speed: "2 Mbps",
      price: "2,000 AF",
      period: "/mo",
      features: [
        "Ultimate Speed for Gaming",
        "Pro Gaming Router",
        "DDoS Protection",
        "Unlimited Data",
        "Static IP Address",
        "24/7 Dedicated Support",
      ],
      popular: false,
    },
  ];

  return (
    <section className="py-5 bg-slate-50 text-slate-900">
      <div className="container mx-auto px-6 max-w-screen-xl">
        {/* --- Section Header --- */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <span className="text-blue-600 font-bold tracking-wider uppercase text-xs">
            Plans & Pricing
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mt-2 mb-6 text-slate-900">
            Choose Your Speed
          </h2>
          <p className="text-lg text-slate-600">
            No hidden fees. No contracts. Just high-speed internet tailored to
            your lifestyle.
          </p>
        </div>

        {/* --- Plans Grid --- */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          {plans.map((plan) => (
            <PricingCard key={plan.id} plan={plan} />
          ))}
        </div>
      </div>
    </section>
  );
};

// --- Reusable Pricing Card Component ---
const PricingCard = ({ plan }) => (
  <div
    className={`
    relative bg-white p-8 rounded-2xl shadow-sm border transition-all duration-300 hover:shadow-xl
    ${
      plan.popular
        ? "border-blue-500 border-2 scale-105 z-10"
        : "border-slate-200"
    }
  `}
  >
    {/* Popular Badge (Only for Middle Card) */}
    {plan.popular && (
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <span className="bg-blue-600 text-white text-xs font-bold uppercase tracking-widest px-4 py-1 rounded-full shadow-md">
          Most Popular
        </span>
      </div>
    )}

    {/* Plan Name */}
    <h3 className="text-xl font-bold text-slate-900 mb-2">{plan.name}</h3>

    {/* Speed Indicator */}
    <p className="text-blue-600 font-bold text-2xl mb-6">{plan.speed}</p>

    {/* Price */}
    <div className="flex items-baseline mb-8">
      <span className="text-5xl font-extrabold text-slate-900">
        {plan.price}
      </span>
      <span className="text-slate-500 ml-1">{plan.period}</span>
    </div>

    {/* Features List */}
    <ul className="space-y-4 mb-10">
      {plan.features.map((feature, index) => (
        <li key={index} className="flex items-center text-sm text-slate-600">
          <svg
            className="w-5 h-5 text-green-500 mr-3 flex-shrink-0"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
          {feature}
        </li>
      ))}
    </ul>

    {/* CTA Button */}
    <button
      className={`
      w-full py-3 rounded-lg font-bold transition-colors duration-300
      ${
        plan.popular
          ? "bg-blue-600 hover:bg-blue-700 text-white shadow-lg"
          : "bg-slate-100 hover:bg-slate-200 text-slate-900"
      }
    `}
    >
      {plan.popular ? "Get Started Now" : "Select Plan"}
    </button>
  </div>
);

export default PricingPlansSection;
